import { sendAnalytics } from '@audio-network/analytics'

import { AutocompletePlugin } from '@/components/pages/search/SearchBox/SearchBox.types'
import type { AutocompleteFetcher } from '@/utils/algolia/autocomplete'
import { shouldShowCuratedAutocompleteSections } from '@/utils/algolia/autocomplete/utils'
import type { PlaylistHit } from '@/utils/algolia/autocompleteHitTypes'

export const playlistsPlugin = (
	fetchAutocomplete: AutocompleteFetcher
): AutocompletePlugin<PlaylistHit> => {
	return {
		name: 'playlistsPlugin',
		getSources({ query }) {
			if (!shouldShowCuratedAutocompleteSections(query)) {
				return []
			}

			return [
				{
					sourceId: 'playlistsSource',
					getItemUrl({ item }) {
						return item.url
					},
					getItems({ query }) {
						return fetchAutocomplete(query).then((b) => b.playlistHits)
					},
					onSelect({ item }) {
						sendAnalytics({
							noun: 'Playlist',
							pastTenseVerb: 'Clicked',
							eventParameters: {
								Name: item.value,
								UrlSlug: item.url.split('/').pop(),
								Source: 'Typeahead',
							},
						})
						sendAnalytics({
							noun: 'Typeahead',
							pastTenseVerb: 'Submitted',
							eventParameters: {
								PlaylistTitle: item.value,
								Type: 'Playlist',
							},
						})
					},
				},
			]
		},
	}
}
